<nav>
    <ul (click)="onClick.emit()">
        <li><a [routerLink]="['']" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }"><img src="../../../assets/icons/home.svg" alt="Icon Home" /> Home</a></li>
        <li><a [routerLink]="['work']" [routerLinkActive]="['active']"><img src="../../../assets/icons/work.svg" alt="Icon Work" /> Work</a></li>
        <li><a [routerLink]="['/education', 'avans']" [routerLinkActive]="['active']"><img src="../../../assets/icons/education.svg" alt="Icon Education" /> Education</a></li>
        <li><a [routerLink]="['about']" [routerLinkActive]="['active']"><img src="../../../assets/icons/about.svg" alt="Icon About" /> About</a></li>
    </ul>
</nav>